// import 'babel-polyfill'
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react'
import ReactDOM from 'react-dom'

const __DEV__ = process.env.NODE_ENV === 'development'
const __TEST__ = process.env.NODE_ENV === 'test'
const __PROD__ = process.env.NODE_ENV === 'production'

import(/* webpackMode: "eager" */ './store').then((s) => {
  const createStore = s.default

  // Store Initialization
  // ------------------------------------
  const store = createStore(window.__INITIAL_STATE__)

  // Render Setup
  // ------------------------------------
  const MOUNT_NODE = document.getElementById('root')

  let render = () => {
    const App = require('./containers/App').default
    const routes = require('./routes').default(store)

    ReactDOM.render(
            <App store={store} routes={routes}/>,
            MOUNT_NODE,
    )
  }

  // Development Tools
  // ------------------------------------
  if (__DEV__) {
    if (module.hot) {
      const renderApp = render
      const renderError = (error) => {
        const RedBox = require('redbox-react').default

        ReactDOM.render(<RedBox error={error}/>, MOUNT_NODE)
      }

      render = () => {
        try {
          renderApp()
        } catch (e) {
          console.error(e)
          renderError(e)
        }
      }

      // Setup hot module replacement
      module.hot.accept([
        './containers/App',
        './routes',
      ], () => setImmediate(() => {
        ReactDOM.unmountComponentAtNode(MOUNT_NODE)
        render()
      }),
      )
    }
  }

  // Let's Go!
  // ------------------------------------
  if (!__TEST__) render()
})



// WEBPACK FOOTER //
// ./main/src/main.js